/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

/* eslint-disable no-console */
//console.log( 'Hello World! (from sp/main-banner block)' );
/* eslint-enable no-console */

var $ = jQuery.noConflict();

document.addEventListener("DOMContentLoaded", function () {
	console.log("Setting portfolio single");
	setPortfolioSingle();
});

function setPortfolioSingle() {
	var splide = new Splide("#sp-porfolio-single-carousel", {
		// type: "loop",
		// rewind: "true",
		pagination: false,
		keyboard: true,
	});

	var thumbnails = document.getElementsByClassName("portfolio-single-image");
	var current;

	for (var i = 0; i < thumbnails.length; i++) {
		initThumbnail(thumbnails[i], i);
	}

	function initThumbnail(thumbnail, index) {
		thumbnail.addEventListener("click", function () {
			$("body").css("overflow", "hidden");
			$("#sp-porfolio-single-carousel").removeClass("hidden").addClass("block");
			console.log("index clicked:", index);
			splide.refresh();
			splide.go(index);
		});
	}

	// splide.on("mounted move", function () {
	// 	var thumbnail = thumbnails[splide.index];

	// 	if (thumbnail) {
	// 		if (current) {
	// 			current.classList.remove("is-active");
	// 		}

	// 		thumbnail.classList.add("is-active");
	// 		current = thumbnail;
	// 	}
	// });

	splide.mount();

	$(document).on("keydown", function (e) {
		if (e.key == "Escape") {
			onEscape();
		}
	});
	$(".porfolio-single-close").on("click", function () {
		onEscape();
	});

	function onEscape() {
		$("body").css("overflow", "visible");
		$("#sp-porfolio-single-carousel").removeClass("block").addClass("hidden");
	}
}
